"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");
/**
 * A mediator that can mediate over a single number field.
 *
 * It takes the required 'field' and 'type' parameters.
 * The 'field' parameter represents the field name of the test result field over which must be mediated.
 * The 'type' parameter
 */


var MediatorNumber =
/*#__PURE__*/
function (_core_1$Mediator) {
  _inherits(MediatorNumber, _core_1$Mediator);

  function MediatorNumber(args) {
    var _this;

    _classCallCheck(this, MediatorNumber);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediatorNumber).call(this, args));
    _this.indexPicker = _this.createIndexPicker();
    return _this;
  }
  /**
   * @return {(tests: T[]) => number} A function that returns the index of the test result
   *                                  that has been chosen by this mediator.
   */


  _createClass(MediatorNumber, [{
    key: "createIndexPicker",
    value: function createIndexPicker() {
      var _this2 = this;

      switch (this.type) {
        case MediatorNumber.MIN:
          return function (tests) {
            return tests.reduce(function (a, b, i) {
              var val = _this2.getOrDefault(b[_this2.field], Infinity);

              return val !== null && (isNaN(a[0]) || a[0] > val) ? [val, i] : a;
            }, [NaN, -1])[1];
          };

        case MediatorNumber.MAX:
          return function (tests) {
            return tests.reduce(function (a, b, i) {
              var val = _this2.getOrDefault(b[_this2.field], -Infinity);

              return val !== null && (isNaN(a[0]) || a[0] < val) ? [val, i] : a;
            }, [NaN, -1])[1];
          };
      }

      throw new Error('No valid "type" value was given, must be either ' + MediatorNumber.MIN + ' or ' + MediatorNumber.MAX + ', but got: ' + this.type);
    }
  }, {
    key: "getOrDefault",
    value: function getOrDefault(value, defaultValue) {
      return value === undefined ? defaultValue : value;
    }
  }, {
    key: "mediateWith",
    value: function () {
      var _mediateWith = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, testResults) {
        var promises, errors, dummy, results, index;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                promises = testResults.map(function (_ref) {
                  var reply = _ref.reply;
                  return reply;
                });
                errors = [];

                if (this.ignoreErrors) {
                  dummy = {};
                  dummy[this.field] = null;
                  promises = promises.map(function (p) {
                    return p.catch(function (error) {
                      errors.push(error);
                      return dummy;
                    });
                  });
                }

                _context.next = 5;
                return Promise.all(promises);

              case 5:
                results = _context.sent;
                index = this.indexPicker(results);

                if (!(index < 0)) {
                  _context.next = 9;
                  break;
                }

                throw new Error('All actors rejected their test in ' + this.name + '\n' + errors.map(function (e) {
                  return e.toString();
                }).join('\n'));

              case 9:
                return _context.abrupt("return", testResults[index].actor);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mediateWith(_x, _x2) {
        return _mediateWith.apply(this, arguments);
      }

      return mediateWith;
    }()
  }]);

  return MediatorNumber;
}(core_1.Mediator);

MediatorNumber.MIN = "https://linkedsoftwaredependencies.org/bundles/npm/@comunica/mediator-number/" + "Mediator/Number/type/TypeMin";
MediatorNumber.MAX = "https://linkedsoftwaredependencies.org/bundles/npm/@comunica/mediator-number/" + "Mediator/Number/type/TypeMax";
exports.MediatorNumber = MediatorNumber;